import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-116632b9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "alinhamentoTooltip" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Visualizar Documento", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Baixar Documento", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Detalhes do Documento", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Cancelar", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FilePdfOutlined = _resolveComponent("FilePdfOutlined")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_progress = _resolveComponent("a-progress")!
  const _component_EyeOutlined = _resolveComponent("EyeOutlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_DownloadOutlined = _resolveComponent("DownloadOutlined")!
  const _component_UnorderedListOutlined = _resolveComponent("UnorderedListOutlined")!
  const _component_CloseOutlined = _resolveComponent("CloseOutlined")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_EnvelopeDetails = _resolveComponent("EnvelopeDetails")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_CancelEnvelopeModal = _resolveComponent("CancelEnvelopeModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_table, {
      size: "small",
      columns: _ctx.columns,
      "data-source": _ctx.envelopsINeedToSign,
      "row-key": (record) => record.id,
      pagination: false,
      scroll: {y: 580 },
      style: {"overflow-x":"hidden"},
      onResizeColumn: _ctx.handleResizeColumn
    }, {
      name: _withCtx(({ text }) => [
        _createVNode(_component_a_tooltip, null, _createSlots({
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("span", null, [
                _createVNode(_component_FilePdfOutlined),
                _createTextVNode(" " + _toDisplayString(text), 1)
              ])
            ])
          ]),
          _: 2
        }, [
          (text.length <= 200 )
            ? {
                name: "title",
                fn: _withCtx(() => [
                  _createTextVNode(_toDisplayString(text), 1)
                ]),
                key: "0"
              }
            : {
                name: "title",
                fn: _withCtx(() => [
                  _createTextVNode(_toDisplayString(text.substring(0, 200)) + "...", 1)
                ]),
                key: "1"
              }
        ]), 1024)
      ]),
      progress: _withCtx(({ record }) => [
        _createVNode(_component_a_tooltip, null, {
          title: _withCtx(() => [
            _createTextVNode(_toDisplayString(record.startProgress) + " de " + _toDisplayString(record.endProgress) + " assinou o documento", 1)
          ]),
          default: _withCtx(() => [
            (_ctx.documentCanceled(record))
              ? (_openBlock(), _createBlock(_component_a_progress, {
                  key: 0,
                  percent: _ctx.progressBar(record),
                  size: "small",
                  status: _ctx.progressColor(record),
                  steps: record.startProgress
                }, null, 8, ["percent", "status", "steps"]))
              : (_openBlock(), _createBlock(_component_a_progress, {
                  key: 1,
                  percent: 100,
                  status: "exception",
                  steps: 5,
                  size: "small",
                  "stroke-color": "red"
                }))
          ]),
          _: 2
        }, 1024)
      ]),
      action: _withCtx(({ record }) => [
        _createVNode(_component_a_space, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_tooltip, null, {
              title: _withCtx(() => [
                _hoisted_2
              ]),
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "primary",
                  shape: "circle",
                  size: "small",
                  onClick: ($event: any) => (_ctx.viewerDocument(record))
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_EyeOutlined)
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_a_tooltip, null, {
              title: _withCtx(() => [
                _hoisted_3
              ]),
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "primary",
                  shape: "circle",
                  size: "small",
                  onClick: ($event: any) => (_ctx.downDocument(record))
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_DownloadOutlined)
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 2
            }, 1024),
            (record.status === 1)
              ? (_openBlock(), _createBlock(_component_a_tooltip, { key: 0 }, {
                  title: _withCtx(() => [
                    _hoisted_4
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      type: "primary",
                      shape: "circle",
                      size: "small",
                      onClick: ($event: any) => (_ctx.viewerDetailsDocument(record))
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_UnorderedListOutlined)
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true),
            (record.status === 1)
              ? (_openBlock(), _createBlock(_component_a_tooltip, { key: 1 }, {
                  title: _withCtx(() => [
                    _hoisted_5
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      type: "danger",
                      shape: "circle",
                      size: "small",
                      onClick: ($event: any) => (_ctx.openCancelModal(record))
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_CloseOutlined)
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true)
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    }, 8, ["columns", "data-source", "row-key", "onResizeColumn"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.isShowDetailsDocument,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isShowDetailsDocument) = $event)),
      centered: "",
      footer: null,
      maskClosable: false,
      closable: false,
      width: "1000px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_EnvelopeDetails, {
          hashIdDocument: _ctx.hashIdDocument,
          detailsDocument: _ctx.detailsDocument,
          onCloseModalDetails: _ctx.closeModalDetails
        }, null, 8, ["hashIdDocument", "detailsDocument", "onCloseModalDetails"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_CancelEnvelopeModal, {
      visible: _ctx.isShowCancelModal,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isShowCancelModal) = $event)),
      envelope: _ctx.envelopeToCancel,
      onCanceled: _ctx.onEnvelopeCanceled
    }, null, 8, ["visible", "envelope", "onCanceled"])
  ], 64))
}